/**** cat.Branch */

const config = {
  schema: 'mgt',
  table: 'Depot',
  title: 'Филиалы',
  elemsOnPage: 10,
  connections: {
    agencies: {
      schema: 'mgt',
      table: 'Agency',
      index: 'agency_id',
      fields: ['title'],
      format: (elem: any) => elem['title']
    },
  },
  fields: [
    {
      name: 'depot_id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
      hide: true,
    },
    {
      name: 'depot_name',
      title: 'Наименование',
      type: 'text',
      required: true,
      hide: true,
    },
    {
      name: 'address',
      title: 'Адрес',
      type: 'text',
      required: false,
    },
    {
      name: 'phone',
      title: 'Телефон',
      type: 'text',
      required: false,
    },
    {
      name: 'agency_id',
      title: 'Предприятие перевозчика',
      type: 'number',
      required: true,
      connection: 'agencies',
      link: 'agency'
    },
    {
      name: 'dp_lat',
      title: 'Широта',
      type: 'text',
      required: false,
      hide: true,
      disableFilter: true,
    },
    {
      name: 'dp_lon',
      title: 'Долгота',
      type: 'text',
      required: false,
      hide: true,
      disableFilter: true,
    },
    {
      title: 'Координаты',
      type: 'map',
      disableFilter: true,
      composite: {
        type: 'point_coords',
        lat: 'dp_lat',
        lon: 'dp_lon',
      },
    },
  ],
  makeTitle: (elem: any, connections: { [key: string]: any }): string => {
    return elem['depot_name'];
  },
  makeAdditional: (elem: any, connections: { [key: string]: any }): string => {
    const ag =
      connections &&
      connections['agencies'] &&
      connections['agencies'].find((ag: any) => ag['agency_id'] === elem['agency_id']);
    return `${
      ag ? 'Предприятие: ' + ag.title + '; ' : ''
    } Адрес: ${elem.address || '-'}; Телефон: ${elem.phone || '-'};`;
  },
  defaultSort: {
    field: 'depot_id',
    direction: 'desc',
  },
};

export default config;
